import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  width: 100%;
  height: calc(100vh - 3.56rem);

  margin: 0 auto;
  max-width: ${({ theme }) => theme.grid.container};
  padding-top: 1.93rem;
  padding-left: 1rem;
  padding-right: 1rem;

  display: flex;
  flex-direction: column;
`;

export const ChildrenWrapper = styled.div`
  margin-top: 2.5rem;
  width: 100%;
`;
